import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
import SimplePagination from "./SimplePagination";
class DashboardAdmin extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            teams: [],
            total:0,
            maxRecords:10,
            selectedInstance: null,  
            token: null,
            page: 1,
            isAuthenticated: false,
            rfc:'',
            status:'',
            accountType:'',
            accountTypes:[],
            instances:[],
            showModal: false, // Estado para manejar el modal
        };
        this.toggleExpand = this.toggleExpand.bind(this); 
        this.toggleModal = this.toggleModal.bind(this); // Método para manejar la visibilidad del modal
    }
    updateCurrentPage = (page) =>{
        this.setState({page: page}, function () {
            this.getInstanceTeams();
        });
    }
    getInstanceTeams = async ()=>{
        var url = '/api/team_instances';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if (this.state.rfc !== '') {
            query.append('rfc', this.state.rfc);
        }
        if (this.state.status !== '') {
            query.append('status', this.state.status);
        }
        if (this.state.accountType !== '') {
            query.append('licence', this.state.accountType);
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({teams: data, total: res.data.total});
    }
    getAccountTypes = ()=>{
        axios.get('/api/account-types').then(res=>{
            this.setState({accountTypes: res.data});
        })
    }
    fetchInstancesData = () =>{
        axios.post('/api/get_intances_data').then(res=>{
            // location.reload()
        })
    }
    async componentDidMount() { 
        await this.fetchInstancesData();  
        await this.getAccountTypes(); 
        await this.getInstances();
        await this.getInstanceTeams();  
    }
    getInstances = () => {  
        axios.get('/api/instances')
            .then(response => { 
                const instances = response.data.slice(1);
                this.setState({ instances }); 
            }) 
            .catch(error => {
                console.error(getErrorsMessage(error));
            });
    };

    handleInstanceChange = (event) => {
        const selectedInstanceId = event.target.value;
        const selectedInstance = this.state.instances.find(instance => instance.id === parseInt(selectedInstanceId)); 
        this.setState({ selectedInstance } );
    }; 
    handleLogin = (event) => {
        event.preventDefault();
        const { selectedInstance,   token } = this.state; 
        this.saveCredentials(selectedInstance.id,token);
    };

    saveCredentials = (instanceId,   token) => {
        axios.post(`/api/instance-credentials`, {
            instance_id: instanceId, 
            token: token
        }).then(response => {
            location.reload()
        }).catch(error => {
            console.error("Failed to save credentials:", getErrorsMessage(error));
        });
    };

    getInstanceDetails = () => {
        const { selectedInstance, token } = this.state;
        if (selectedInstance && token) {
            axios.get(`${selectedInstance.url}/api/admin/dashboard`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                console.log("Instance details:", response.data); 
            })
            .catch(error => {
                console.error("Failed to fetch instance details:", getErrorsMessage(error));
            });
        }
    };

    

    handleInputChange = (event) => {
        const { name, value } = event.target;
        
        this.setState({ [name]: value }, () => {
            // Reset filters if "Seleccionar tipo de cuenta" is selected
            if (name === 'accountType' && value === '') {
                this.setState({ accountType: '' }, this.getInstanceTeams);
            } else {
                this.getInstanceTeams();
            }
        });
    };

    getInfo = () =>{ 
        let data = [];
        axios.post(`${this.state.selectedInstance.url}/api/dashboard_data`, data, {
            headers: {
                'Authorization': `Bearer ${this.state.selectedInstance.token}`,
                'Content-Type': 'application/json'
            },
            withCredentials: true
            }).then(response => {
            console.log("Instance details:", response.data);
        })
        .catch(error => {
            console.error("Failed to fetch instance details:", getErrorsMessage(error));
        }); 
    }
    toggleExpand(teamId) {
        const teamRow = document.querySelector(`.expandable-head-row-${teamId}`);
        const expandRows = document.querySelectorAll(`.expandable-row-${teamId}`);
        const expandIcon = document.querySelector(`i[data-team-id="${teamId}"]`);
        
        expandRows.forEach(row => {
            row.style.display = row.style.display === 'none' ? '' : 'none';
        });

        if (expandIcon.classList.contains('flaticon2-plus')) {
            expandIcon.classList.replace('flaticon2-plus', 'flaticon2-line');
            teamRow.style.fontWeight = 'bold';
            teamRow.style.borderTop = '3px solid #c3c3c3';
            expandRows[expandRows.length - 1].style.borderBottom = '3px solid #c3c3c3';
        } else {
            expandIcon.classList.replace('flaticon2-line', 'flaticon2-plus');
            teamRow.style.fontWeight = 'normal';
            teamRow.style.borderTop = 'none';
            expandRows[expandRows.length - 1].style.borderBottom = 'none';
        }
    }
    toggleModal() {
        this.setState(prevState => ({ showModal: !prevState.showModal }));
    }
    render() {
        const { lang } = this.context;
        const { instances, selectedInstance, isAuthenticated,showModal,accountTypes } = this.state;

        return (
            <div>
                {/* Fila de filtros */}
            <div className="row mb-3" style={{ backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
                <div className="col-md-4">
                    <select className="form-control" name="accountType" onChange={this.handleInputChange}>
                        <option value="">Seleccionar tipo de cuenta</option>
                        {accountTypes.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.title}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <select className="form-control" name="status" onChange={this.handleInputChange}>
                        <option value="">Seleccionar estatus</option>
                        <option value="Vigente">Vigente</option>
                        <option value="Expirado">Expirado</option>
                        <option value="Cancelado">Cancelado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        name="rfc"
                        placeholder="Filtrar por RFC"
                        onChange={this.handleInputChange}
                    />
                </div>
            </div>
                <h1>{lang.dashboardAdmin}</h1>
                <button className="btn btn-primary ml-5" onClick={this.toggleModal}>
                    Listado de instancias
                </button>
                
                 {/* Modal */}
                {showModal && (
                    <div className="modal fade show d-block" id="instancesModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content" style={{ background: '#f5f5f5' }}>
                                <div className="modal-body px-15 py-5 mt-4">
                                    <h3>Instancias</h3>
        
                                    <table className="table table-striped bbotom-table mt-4"> 
                                    <thead>
                                    <tr> 
                                    </tr>
                                    </thead>
                                        <tbody>
                                            {instances.map(instance => (
                                                <tr key={instance.id}>
                                                    <td>
                                                        <div  className="d-flex ">

                                                        <div className="symbol-label mr-3 ">
                                                        <span className="flaticon2-cube text-primary icon-md"></span>
                                                    </div>
                                                        {instance.name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {!instance.hasCredentials && (
                                                            <input
                                                                type="text"
                                                                name="token"
                                                                placeholder="Ingresa el token"
                                                                className="form-control"
                                                                onChange={this.handleInputChange}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {!instance.hasCredentials && (
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={() => this.saveCredentials(instance.id, this.state.token)}
                                                            >
                                                                Conectar
                                                            </button>
                                                        )}
                                                        {instance.hasCredentials && (   
                                                            <span> <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}><i className="symbol-badge bg-success"></i></div> Conectado</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <button className="btn btn-secondary" onClick={this.toggleModal}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
               
                <table class="table table-striped">
    <thead>
        <tr>
            <th>Instance</th>
            <th>Empresa</th>
            <th>RFC / RUT</th>
            <th>Creación</th>
            <th>Tipo de licencia</th>
            <th>Propietario </th>
            <th>Archivos</th>
            <th>Expedientes</th>
            <th>Invitados</th>
            <th>Estatus</th>
            <th>Empresas</th>
        </tr>
    </thead>
        <tbody>
        {this.state.teams.map((team) => (
               <React.Fragment key={team.id}>
            <tr className={`expandable-head-row-${team.id}`}  > 
          
            <td> {team.instance.name} </td>
                <td><i  className="flaticon2-plus expand-btn mr-4 text-primary"   style={{ fontSize: '0.80rem', cursor: 'pointer' }} onClick={() => this.toggleExpand(team.id)}   data-team-id={team.id}   ></i>
                    {team.is_multi_company === 1 ? (
                        <div  className="symbol symbol-30 bg-gray-100"   data-toggle="collapse"   data-target={`#collapseExample${team.id}`}   role="button"   aria-expanded="false"
                            aria-controls={`collapseExample${team.id}`}  >
                            <div className="symbol-label">
                                <span className="flaticon2-layers-2 text-primary icon-md"></span>
                            </div>
                        </div>
                    ) : (
                        <div className="symbol symbol-30 bg-gray-100"  data-toggle="collapse"    data-target={`#collapseExample${team.id}`}   role="button" aria-expanded="false" aria-controls={`collapseExample${team.id}`} >
                            <div className="symbol-label">
                                <span className="flaticon2-cube text-primary icon-md"></span>
                            </div>
                        </div>
                    )} 
                    <a className="ml-2"  >   {team.fiscal_name}  </a> 
                </td>
                <td>{team.rfc }</td>
                <td>{team.created }</td>
                <td>
                    <span className={`badge badge-inline badge-pill ${
                            team.licence == 1
                                ? "badge-demo"
                                : team.licence == 2
                                ? "badge-compartida"
                                : team.licence == 3
                                ? "badge-local"
                                : team.licence == 4
                                ? "badge-success"
                                : team.licence == 7
                                ? "badge-compartida"
                                : team.licence == 5
                                ? "badge-comercial"
                                : ""
                        }`} >
                    {this.state.accountTypes.find(type => type.id == team.licence)?.title || 'N/A'}
                    </span>
                </td>
                <td> {team.owner}  </td>
                <td> {team.files} (  {team.size} ) MB  </td> 
                <td> {team.dossiers  }  </td>
                <td> {team.total_providers  }   </td>
                <td  dangerouslySetInnerHTML={{ __html: team.status || '' }}   />
                <td> {team.total_empresas  }   </td>
            </tr> 
            {team.empresas.map(empresa => (
                <tr key={empresa.id} className={`expandable-row-${team.id}`}  style={{ display: 'none' }} >
                    <td rowsSpan={3}></td>
                    <td>
                        <div className="symbol symbol-30 bg-gray-100" style={{ marginLeft: '28px' }}   data-toggle="collapse"  role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div className="symbol-label">
                                <span className="flaticon2-cube text-primary icon-md"></span>
                            </div>
                        </div> 
                        <a 
                            className="ml-2" 
                            href={`/admin/person/${empresa.instance_id}/show/${empresa.people_id}`}
                        >
                            {empresa.fiscal_name}
                        </a>
                    </td>
                    <td>{empresa.rfc} </td>
                    <td>{empresa.created} </td>
                    <td>
                    <span className={`badge badge-inline badge-pill ${
                            empresa.licence == 1
                            ? "badge-demo"
                            : empresa.licence == 2
                            ? "badge-compartida"
                            : empresa.licence == 3
                            ? "badge-local"
                            : empresa.licence == 4
                            ? "badge-success"
                            : empresa.licence == 7
                            ? "badge-compartida"
                            : empresa.licence == 5
                            ? "badge-comercial"
                            : ""
                        }`} >
                    {this.state.accountTypes.find(type => type.id == empresa.licence)?.title || 'N/A'}
                    </span>
                </td>
                <td> {empresa.owner_email || empresa.owner}  </td>
                <td> {empresa.files} (  {empresa.size} ) MB  </td> 
                <td> {empresa.dossiers  }  </td>
                <td> {empresa.total_providers  }   </td>
                <td  dangerouslySetInnerHTML={{ __html: empresa.status || '' }}   />
                </tr>
                ))}
            </React.Fragment>
        ))}
        </tbody>
      </table>
      {this.state.total > this.state.maxRecords   &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
        );
    }
}

export default DashboardAdmin;

if (document.getElementById('DashboardAdmin')) {
    ReactDOM.render(<DashboardAdmin />, document.getElementById('DashboardAdmin'));
}
